function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { centsToThousandUsdString, thousandUsdToCentsString } from '@paperstac/helpers/lib/numberHelpers';
import React from 'react';
import { connectRange } from 'react-instantsearch-dom';
import Flex from './Flex';
import Input from './form/Input';
import Prefix from './form/Prefix';
import Suffix from './form/Suffix';
import Text from './Text';
export const ALGOLIA_RANGE_INPUT_MIN = 0;
export const ALGOLIA_RANGE_INPUT_MAX = 100000000000;
const BaseAlgoliaRangeInput = /*#__PURE__*/React.memo(_ref => {
  let {
    currentRefinement,
    max,
    min,
    prefix,
    refine,
    sanitizeValue,
    suffix,
    transformValue
  } = _ref;
  const handleChange = _ref2 => {
    let {
      target
    } = _ref2;
    const newRefinement = {
      ...currentRefinement,
      [target.name]: sanitizeValue(target.value)
    };
    if (newRefinement.min === '' || newRefinement.min === min) delete newRefinement.min;
    if (newRefinement.max === '' || newRefinement.max === max) delete newRefinement.max;
    refine(newRefinement);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    fontSize: 1
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1
  }, !!prefix && /*#__PURE__*/React.createElement(Prefix, {
    px: 2
  }, prefix), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    px: 2,
    flex: 1,
    name: "min",
    placeholder: "min",
    value: min !== currentRefinement.min ? transformValue(currentRefinement.min) : '',
    onChange: handleChange,
    hasPrefix: !!prefix,
    hasSuffix: !!suffix
  }), !!suffix && /*#__PURE__*/React.createElement(Suffix, {
    px: 2
  }, suffix)), /*#__PURE__*/React.createElement(Text, {
    mx: 2
  }, "to"), /*#__PURE__*/React.createElement(Flex, {
    flex: 1
  }, !!prefix && /*#__PURE__*/React.createElement(Prefix, {
    px: 2
  }, prefix), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    px: 2,
    flex: 1,
    name: "max",
    placeholder: "max",
    value: max !== currentRefinement.max ? transformValue(currentRefinement.max) : '',
    onChange: handleChange,
    hasPrefix: !!prefix,
    hasSuffix: !!suffix
  }), !!suffix && /*#__PURE__*/React.createElement(Suffix, {
    px: 2
  }, suffix)));
});
const ConnectedAlgoliaRangeInput = connectRange(BaseAlgoliaRangeInput);
const getPropsFromFormat = format => {
  switch (format) {
    case 'thousandUsd':
      return {
        prefix: '$',
        suffix: 'K',
        transformValue: value => centsToThousandUsdString(value, 1, true),
        sanitizeValue: value => {
          const val = thousandUsdToCentsString(value);
          if (val) {
            if (+val < ALGOLIA_RANGE_INPUT_MIN) return ALGOLIA_RANGE_INPUT_MIN;
            if (+val > ALGOLIA_RANGE_INPUT_MAX) return ALGOLIA_RANGE_INPUT_MAX;
          }
          return val;
        }
      };
    default:
      return {
        prefix: null,
        suffix: null,
        transformValue: val => val,
        sanitizeValue: val => {
          if (val) {
            if (+val < ALGOLIA_RANGE_INPUT_MIN) return ALGOLIA_RANGE_INPUT_MIN;
            if (+val > ALGOLIA_RANGE_INPUT_MAX) return ALGOLIA_RANGE_INPUT_MAX;
          }
          return val;
        }
      };
  }
};
const AlgoliaRangeInput = _ref3 => {
  let {
    format,
    ...props
  } = _ref3;
  const formatProps = getPropsFromFormat(format);
  return /*#__PURE__*/React.createElement(ConnectedAlgoliaRangeInput, _extends({
    min: ALGOLIA_RANGE_INPUT_MIN,
    max: ALGOLIA_RANGE_INPUT_MAX
  }, formatProps, props));
};
AlgoliaRangeInput.propTypes = {};
AlgoliaRangeInput.defaultProps = {};
AlgoliaRangeInput.displayName = 'AlgoliaRangeInput';
export default AlgoliaRangeInput;